import React, { Component } from 'react'

export default class AddYourContent extends Component {
    render() {
        return (
            <section>
            <div class="container main-container bg-light m-5 mx-auto">
              <div class="d-flex justify-content-center align-items-center flex-column">
                <div class="main-wrap row w-100 d-none justify-content-center align-items-center">
                  {/* <!-- <div id="image-input-one" class="col-md-12 wrap-input-one"></div> --> */}
                </div>
  
                <hr />
  
                <h5 class="add-content edit-mode">Add your content</h5>
                <div class="column edit-mode details py-3 row w-50 mx-auto justify-content-center">
                  <button
                    id="one-column"
                    class="col-md-3 m-1 btn btn-secondary mx-1"
                  >
                    One Column
                  </button>
                  <button
                    id="two-column"
                    class="col-md-3 m-1 btn btn-secondary mx-1"
                  >
                    Two Column
                  </button>
                  <button
                    id="three-column"
                    class="col-md-3 m-1 btn btn-secondary mx-1"
                  >
                    Three Column
                  </button>
                </div>
  
                <div class="input-div">
                  {/* <!-- <input type="file" class="edit-mode" id="input-1" name="image" accept="image/*" capture style="display:none" /> --> */}
                </div>
              </div>
            </div>
          </section>
        )
    }
}
